import PropTypes from 'prop-types';
import React from 'react';
import PopUp from '../PopUp';

import './SuccessPopup.scss';

const SuccessPopup = ({
    title,
    secondaryText,
    buttonText,
    buttonOnClick,
    cancelButtonOnClick,
    className,
    minHeight,
    minWidth,
    hideCloseButton,
}) => {
    return (
        <div className="component-Elements-PopUp-SuccessPopup">
            <PopUp
                className={className}
                showPopUp
                absolutePosition
                showOverlay
                cancel={cancelButtonOnClick}
                showLogo={false}
                maxHeight="370px"
                maxWidth="360px"
                close={buttonOnClick}
                buttonText={buttonText}
                minHeight={minHeight}
                minWidth={minWidth}
                hideCloseButton={hideCloseButton}
            >
                <div className="title">{title}</div>
                <div className="popupText">{secondaryText}</div>
            </PopUp>
        </div>
    );
};

SuccessPopup.propTypes = {
    /**
     * title text
     */
    title: PropTypes.string.isRequired,
    /**
     * secondary text if wanted
     */
    secondaryText: PropTypes.string,
    /**
     * button text if needed
     */
    buttonText: PropTypes.string.isRequired,
    /**
     * button click function
     */
    buttonOnClick: PropTypes.func.isRequired,
    /**
     * cancel "X" click function
     */
    cancelButtonOnClick: PropTypes.func,
    /**
     * optional class
     */
    className: PropTypes.string,
    minHeight: PropTypes.string,
    minWidth: PropTypes.string,
    /**
     * whether to show X on popup
     */
    hideCloseButton: PropTypes.bool,
};

SuccessPopup.defaultProps = {
    secondaryText: '',
    cancelButtonOnClick: () => {},
    className: '',
    minHeight: '',
    minWidth: '',
    hideCloseButton: false,
};

SuccessPopup.displayName = 'SuccessPopup';

export default SuccessPopup;
